import { render, staticRenderFns } from "./TeacherMembershipModal.vue?vue&type=template&id=22fdcd00&scoped=true&"
import script from "./TeacherMembershipModal.vue?vue&type=script&lang=js&"
export * from "./TeacherMembershipModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fdcd00",
  null
  
)

export default component.exports